import Utils from "platform/util/Utils";

enum CreditCardType {

    None = "none",
    Amex = "amex",
    Dankort = "dankort",
    Dinersclub = "dinersclub",
    Discover = "discover",
    Elo = "elo",
    Hipercard = "hipercard",
    Jcb = "jcb",
    Laser = "laser",
    Mastercard = "mastercard",
    Maestro = "maestro",
    Mir = "mir",
    Troy = "troy",
    Unionpay = "unionpay",
    Visa = "visa",
}

namespace CreditCardType {

    export function deserialize(v: string): CreditCardType {
        if (Utils.isNotEmpty(v)) {
            const keys: string[] = Object.keys(CreditCardType);
            for (let i = 0; i < keys.length; i++) {
                if (CreditCardType[keys[i]] === v) {
                    return v as CreditCardType;
                }
            }
        }
        return CreditCardType.None;
    }
}

export {
    CreditCardType
};
